export default __webpack_public_path__ + "static/media/icon-product-adoption.80184190.svg";